import React from 'react';
import Fade from 'react-reveal/Fade';

export default function ReferAndWin() {
  return (
    <section className="waya-refer-section py-5">
      <div className="container">
        <div className="waya-refer-card">
          <div className="row align-items-center">
            <div className="col-lg-7 px-lg-5">
              <Fade left>
                <h6 className="waya-section-badge text-white opacity-75">Rewards Program</h6>
                <h2 className="waya-section-heading text-white mt-3">THE WAYAGANG</h2>
                <p className="waya-section-subline text-white opacity-90 mt-4">
                  You love banking with us — why not get paid to say so? Every friend you bring to WayaBank puts something back in your pocket. When someone you refer opens a WayaBank account and completes their first transaction, you both earn ₦XXX. <span style={{ color: '#fff', textDecoration: 'underline', cursor: 'pointer', fontWeight: '800' }} onClick={() => window.dispatchEvent(new CustomEvent('waya-open-download-popup'))}>Get your reward link</span>. Simple.
                </p>
                <div className="waya-refer-steps mt-5">
                  {[
                    { step: '1', title: 'Share Link', text: 'Share your unique referral link from your WayaBank app.' },
                    { step: '2', title: 'Friend Joins', text: 'Your friend signs up and completes their first transaction.' },
                    { step: '3', title: 'Earn Rewards', text: 'Rewards drop into your accounts — automatically.' }
                  ].map((item, idx) => (
                    <div className="d-flex gap-4 mb-4" key={idx}>
                      <div className="waya-refer-step-num">{item.step}</div>
                      <div>
                        <h4 className="text-white fs-5 fw-bold mb-1">{item.title}</h4>
                        <p className="text-white opacity-75 m-0">{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Fade>
            </div>
            <div className="col-lg-5 text-center mt-5 mt-lg-0">
              <Fade right>
                <div className="waya-refer-cta-box">
                  <h3 className="fw-800 mb-3" style={{ fontSize: '32px' }}>Start Earning Today</h3>
                  <p className="mb-4 text-muted">There's no cap on how many friends you can refer. The more you share, the more you earn.</p>
                  <button
                    onClick={() => window.dispatchEvent(new CustomEvent('waya-open-download-popup'))}
                    className="waya-btn-primary w-100 py-3"
                  >
                    Get Your Reward Link
                  </button>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
